// ===== SCROLL REVEAL =====
function revealOnScroll() {
    document.querySelectorAll('.scroll-reveal').forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.75) {
            el.classList.add('visible');
        }
    });
}

window.addEventListener('scroll', revealOnScroll);
revealOnScroll();

// ===== PARTICLES =====
function createParticles() {
    const container = document.getElementById('particlesContainer');
    if (!container) return;
    for (let i = 0; i < 30; i++) {
        const particle = document.createElement('div');
        particle.classList.add('particle');
        particle.style.left = Math.random() * 100 + '%';
        particle.style.top = Math.random() * 100 + '%';
        particle.style.animationDelay = Math.random() * 20 + 's';
        particle.style.animationDuration = (15 + Math.random() * 25) + 's';
        container.appendChild(particle);
    }
}

createParticles();

// ===== SPEED LINES =====
function createSpeedLines(container) {
    if (!container) return;
    for (let i = 0; i < 10; i++) {
        const line = document.createElement('div');
        line.classList.add('speed-line');
        line.style.top = Math.random() * 100 + '%';
        line.style.animationDelay = Math.random() * 2 + 's';
        line.style.animationDuration = (1.5 + Math.random() * 1) + 's';
        container.appendChild(line);
    }
}

if (document.getElementById('heroSpeedLines')) {
    createSpeedLines(document.getElementById('heroSpeedLines'));
}
if (document.getElementById('kvSpeedLines')) {
    createSpeedLines(document.getElementById('kvSpeedLines'));
}

// ===== SHOWREEL ACCORDION =====
function openPanel(panel) {
    document.querySelectorAll('.sr-panel').forEach(p => p.classList.remove('active'));
    panel.classList.add('active');
}

// ===== SIGNUP HANDLERS =====
// English-only list
var KLAVIYO_LIST_EN = 'Xm7egN'; // WR X DANDADAN (GLOBAL)
var KLAVIYO_COMPANY_ID = 'WAmhx6';

function handleSignup(event) {
    event.preventDefault();
    var form = event.target;
    var emailInput = form.querySelector('input[type="email"]');
    var email = emailInput.value;
    var submitBtn = form.querySelector('button[type="submit"]');
    var origText = submitBtn.textContent;

    // Disable button during submission
    submitBtn.disabled = true;
    submitBtn.textContent = '...';

    if (KLAVIYO_COMPANY_ID) {
        var klaviyoUrl = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID;
        var klaviyoBody = {
            data: {
                type: 'subscription',
                attributes: {
                    custom_source: 'DDD x Williams Landing Page',
                    profile: {
                        data: {
                            type: 'profile',
                            attributes: {
                                email: email
                            }
                        }
                    }
                },
                relationships: {
                    list: {
                        data: {
                            type: 'list',
                            id: KLAVIYO_LIST_EN
                        }
                    }
                }
            }
        };

        fetch(klaviyoUrl, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'revision': '2024-10-15'
            },
            body: JSON.stringify(klaviyoBody)
        }).then(function(res) {
            return res.text().then(function() {
                // 202 = accepted, 200 = ok — both are success
                if (res.status === 202 || res.ok) {
                    showSignupSuccess(form, submitBtn, origText);
                } else {
                    showSignupSuccess(form, submitBtn, origText);
                }
            });
        }).catch(function() {
            submitBtn.disabled = false;
            submitBtn.textContent = origText;
        });
    } else {
        // Dev/mockup mode: show success state
        setTimeout(function() { showSignupSuccess(form, submitBtn, origText); }, 600);
    }
}

function showSignupSuccess(form, btn, origText) {
    btn.textContent = "✓ YOU'RE IN!";
    btn.style.background = '#00c853';
    form.querySelector('input[type="email"]').value = '';
    setTimeout(function() {
        btn.disabled = false;
        btn.textContent = origText;
        btn.style.background = '';
    }, 3000);
}

function handleLine() {
    window.open('https://lin.ee/nQYIcyr', '_blank');
}

function scrollToSignup() {
    document.querySelector('.signup-form').scrollIntoView({ behavior: 'smooth' });
}

// ===== LEGAL MODALS (EN only) =====
function openLegal(type) {
    var content = document.getElementById('legalContent');
    if (type === 'privacy') {
        content.innerHTML = '<h2 style="font-size:20px; margin-bottom:20px; letter-spacing:2px;">PRIVACY &amp; COOKIES POLICY</h2>' +
        '<p style="opacity:0.5; margin-bottom:24px;">Last updated: March 2026</p>' +
        '<p style="margin-bottom:16px;">This policy applies to this campaign page, operated by UNDONE Japan Co., Ltd., 6-31-15 Jingumae, Shibuya-ku, Tokyo 150-0001, Japan (Representative Director: Robert Tran Quoc Wai) in collaboration with Atlassian Williams Racing and DAN DA DAN. We are committed to protecting your information and respecting your privacy.</p>' +
        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Data We Collect</h3>' +
        '<p style="margin-bottom:12px;"><strong>Contact data</strong> (you provide): email address. <strong>User identification data</strong> (automatic): IP address, browser type, OS. <strong>User behaviour data</strong> (automatic): pages viewed, clickstreams, visit lengths. We hold only necessary data for as long as relevant.</p>' +
        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">How Your Data Is Used</h3>' +
        '<p style="margin-bottom:12px;"><strong>Marketing:</strong> email communications about this collaboration (legal basis: explicit consent). <strong>Website improvement:</strong> optimising content (legal basis: legitimate interest). <strong>Analytics/advertising:</strong> traffic measurement, ad effectiveness (legal basis: consent via cookies).</p>' +
        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Third-Party Processors</h3>' +
        '<p style="margin-bottom:12px;"><strong>Klaviyo, Inc.</strong> — email marketing (USA). <strong>Google Analytics (Google LLC)</strong> — web analytics (USA). <strong>Meta Platforms, Inc.</strong> — advertising/remarketing (USA).</p>' +
        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Your Rights (GDPR)</h3>' +
        '<p style="margin-bottom:12px;">Access, rectification, erasure, restrict processing, data portability, object to processing, withdraw consent. Contact: spark@undone.co.jp</p>' +
        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Data Retention &amp; Deletion</h3>' +
        '<p style="margin-bottom:12px;">Retained while subscribed. Removed within 30 days of unsubscribe. Request deletion at spark@undone.co.jp.</p>' +
        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Marketing &amp; Opting Out</h3>' +
        '<p style="margin-bottom:12px;">Only with express consent. Opt out via unsubscribe link in emails or email spark@undone.co.jp.</p>' +
        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Contact</h3>' +
        '<p>spark@undone.co.jp | UNDONE Japan Co., Ltd., 6-31-15 Jingumae, Shibuya-ku, Tokyo 150-0001, Japan</p>';
    } else {
        content.innerHTML = '<h2 style="font-size:20px; margin-bottom:20px; letter-spacing:2px;">TERMS &amp; CONDITIONS</h2>' +
        '<p style="opacity:0.5; margin-bottom:24px;">Last updated: March 2026</p>' +
        '<p style="margin-bottom:16px;">By using this page you agree to these terms. Operated by UNDONE Japan Co., Ltd., 6-31-15 Jingumae, Shibuya-ku, Tokyo 150-0001, Japan (Representative Director: Robert Tran Quoc Wai) in collaboration with Atlassian Williams Racing and DAN DA DAN. We may update terms at any time.</p>' +
        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Products &amp; Availability</h3>' +
        '<p style="margin-bottom:12px;">Limited edition UNDONE × DAN DA DAN × Williams Racing collection — watches, apparel, and accessories. Subject to availability. Handmade variations are normal, not defects.</p>' +
        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Purchases &amp; Payments</h3>' +
        '<p style="margin-bottom:12px;">Processed by third-party platforms. Prices in USD (undone.com) or JPY (undone.co.jp), excluding taxes/duties/shipping. We may modify pricing without notice.</p>' +
        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Shipping &amp; Delivery</h3>' +
        '<p style="margin-bottom:12px;">Protective packaging. Timelines vary by destination and production. International customs/duties are buyer\'s responsibility.</p>' +
        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Returns &amp; Cancellations</h3>' +
        '<p style="margin-bottom:12px;">Limited collectible: no returns/exchanges. All sales final. Cancel within 1 week at spark@undone.co.jp. Damaged items: contact within 14 days with photos.</p>' +
        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Sign-Up &amp; Emails</h3>' +
        '<p style="margin-bottom:12px;">By signing up you agree to receive marketing emails about this collection. Unsubscribe anytime. Data processed per Privacy Policy.</p>' +
        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Intellectual Property</h3>' +
        '<p style="margin-bottom:12px;">Content owned by UNDONE, Atlassian Williams Racing, and licensors. DAN DA DAN owned by Yukinobu Tatsu/SHUEISHA. Anime by Science SARU. Used under license. No reproduction without consent.</p>' +
        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Governing Law</h3>' +
        '<p style="margin-bottom:12px;">Laws of Japan. Exclusive jurisdiction: courts of Tokyo.</p>' +
        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Contact</h3>' +
        '<p>spark@undone.co.jp | UNDONE Japan Co., Ltd., 6-31-15 Jingumae, Shibuya-ku, Tokyo 150-0001, Japan</p>';
    }
    document.getElementById('legalModal').style.display = 'block';
}

// ===== CAROUSEL TIMER =====
(function() {
    var carousel = document.getElementById('signupCarousel');
    if (!carousel) return;
    var imgs = carousel.querySelectorAll('img');
    var current = 0;
    setInterval(function() {
        imgs[current].classList.remove('active');
        current = (current + 1) % imgs.length;
        imgs[current].classList.add('active');
    }, 4000);
})();

// ===== NEON LINE SCROLL TRIGGER =====
(function() {
    var lines = document.querySelectorAll('.checkered-strip, .racing-divider');
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting && !entry.target.classList.contains('neon-fired')) {
                entry.target.classList.add('neon-fired');
            }
        });
    }, { threshold: 0.5 });
    lines.forEach(function(el) { observer.observe(el); });
})();

// ===== PARALLAX on carousel BG =====
(function() {
    var section = document.querySelector('.signup-section-2');
    if (!section) return;
    var imgs = section.querySelector('.carousel-bg');
    window.addEventListener('scroll', function() {
        var rect = section.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
            var offset = (rect.top / window.innerHeight) * 30;
            imgs.style.transform = 'translateY(' + offset + 'px) scale(1.05)';
        }
    });
})();

// ===== SAFETY NET: ensure all sections are visible =====
window.addEventListener('load', function() {
    document.querySelectorAll('.scroll-reveal').forEach(el => el.classList.add('visible'));
});
